/**
 * Generated by orval v7.17.2 🍺
 * Do not edit manually.
 * FacilityFlow API
 * Eine professionelle Web API für Facility Management mit Versionierung, Logging und Observability.
 * OpenAPI spec version: 1.0
 */
import type {
  FacilityFlowCoreModulesOpenItemsDtosConvertOpenItemRequest,
  FacilityFlowCoreModulesOpenItemsDtosCreateOpenItemMessageRequest,
  FacilityFlowCoreModulesOpenItemsDtosCreateOpenItemRequest,
  FacilityFlowCoreModulesOpenItemsDtosOpenItemDto,
  FacilityFlowCoreModulesOpenItemsDtosOpenItemMessageDto,
  FacilityFlowCoreModulesOpenItemsDtosUpdateOpenItemRequest,
  GetApiV1OpenItemsParams
} from '.././models';

import { customInstance } from '../../mutator/custom-instance';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  export const getOpenItems = () => {
/**
 * @summary List open items; scope is "mine" (default), "all" (administration
only) or "reports" (own reports; all reports for administration).
 */
const getApiV1OpenItems = (
    params?: GetApiV1OpenItemsParams,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesOpenItemsDtosOpenItemDto[]>>,) => {
      return customInstance<FacilityFlowCoreModulesOpenItemsDtosOpenItemDto[]>(
      {url: `/api/v1/open-items`, method: 'GET',
        params
    },
      options);
    }
  /**
 * @summary Create a manual open item. A to-do without an assignee is assigned to the caller; a
report (kind 2) goes to the administration.
 */
const postApiV1OpenItems = (
    facilityFlowCoreModulesOpenItemsDtosCreateOpenItemRequest: FacilityFlowCoreModulesOpenItemsDtosCreateOpenItemRequest,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesOpenItemsDtosOpenItemDto>>,) => {
      return customInstance<FacilityFlowCoreModulesOpenItemsDtosOpenItemDto>(
      {url: `/api/v1/open-items`, method: 'POST',
      headers: {'Content-Type': 'application/json; version=1.0', },
      data: facilityFlowCoreModulesOpenItemsDtosCreateOpenItemRequest
    },
      options);
    }
  /**
 * @summary Change a manual open item (creator or administration).
 */
const putApiV1OpenItemsId = (
    id: string,
    facilityFlowCoreModulesOpenItemsDtosUpdateOpenItemRequest: FacilityFlowCoreModulesOpenItemsDtosUpdateOpenItemRequest,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesOpenItemsDtosOpenItemDto>>,) => {
      return customInstance<FacilityFlowCoreModulesOpenItemsDtosOpenItemDto>(
      {url: `/api/v1/open-items/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json; version=1.0', },
      data: facilityFlowCoreModulesOpenItemsDtosUpdateOpenItemRequest
    },
      options);
    }
  /**
 * @summary Delete a manual open item (creator or administration).
 */
const deleteApiV1OpenItemsId = (
    id: string,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/api/v1/open-items/${id}`, method: 'DELETE'
    },
      options);
    }
  /**
 * @summary Mark a manual open item done (assignee, creator or administration).
 */
const postApiV1OpenItemsIdComplete = (
    id: string,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesOpenItemsDtosOpenItemDto>>,) => {
      return customInstance<FacilityFlowCoreModulesOpenItemsDtosOpenItemDto>(
      {url: `/api/v1/open-items/${id}/complete`, method: 'POST'
    },
      options);
    }
  /**
 * @summary Link a report to the task created from it (via `POST /tasks`) and complete the
report (administration only).
 */
const postApiV1OpenItemsIdConvert = (
    id: string,
    facilityFlowCoreModulesOpenItemsDtosConvertOpenItemRequest: FacilityFlowCoreModulesOpenItemsDtosConvertOpenItemRequest,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesOpenItemsDtosOpenItemDto>>,) => {
      return customInstance<FacilityFlowCoreModulesOpenItemsDtosOpenItemDto>(
      {url: `/api/v1/open-items/${id}/convert`, method: 'POST',
      headers: {'Content-Type': 'application/json; version=1.0', },
      data: facilityFlowCoreModulesOpenItemsDtosConvertOpenItemRequest
    },
      options);
    }
  /**
 * @summary Reopen a completed manual open item (assignee, creator or administration).
 */
const postApiV1OpenItemsIdReopen = (
    id: string,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesOpenItemsDtosOpenItemDto>>,) => {
      return customInstance<FacilityFlowCoreModulesOpenItemsDtosOpenItemDto>(
      {url: `/api/v1/open-items/${id}/reopen`, method: 'POST'
    },
      options);
    }
  /**
 * @summary Message thread of a manual open item, oldest first (assignee, creator or administration).
 */
const getApiV1OpenItemsIdMessages = (
    id: string,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesOpenItemsDtosOpenItemMessageDto[]>>,) => {
      return customInstance<FacilityFlowCoreModulesOpenItemsDtosOpenItemMessageDto[]>(
      {url: `/api/v1/open-items/${id}/messages`, method: 'GET'
    },
      options);
    }
  /**
 * @summary Add a message to the thread (assignee, creator or administration). Not possible on a
completed item — reopen it first.
 */
const postApiV1OpenItemsIdMessages = (
    id: string,
    facilityFlowCoreModulesOpenItemsDtosCreateOpenItemMessageRequest: FacilityFlowCoreModulesOpenItemsDtosCreateOpenItemMessageRequest,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesOpenItemsDtosOpenItemMessageDto>>,) => {
      return customInstance<FacilityFlowCoreModulesOpenItemsDtosOpenItemMessageDto>(
      {url: `/api/v1/open-items/${id}/messages`, method: 'POST',
      headers: {'Content-Type': 'application/json; version=1.0', },
      data: facilityFlowCoreModulesOpenItemsDtosCreateOpenItemMessageRequest
    },
      options);
    }
  /**
 * @summary Mark the thread as read for the caller's side — the assignee, or the whole administration
at once.
 */
const postApiV1OpenItemsIdMessagesSeen = (
    id: string,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/api/v1/open-items/${id}/messages/seen`, method: 'POST'
    },
      options);
    }
  return {getApiV1OpenItems,postApiV1OpenItems,putApiV1OpenItemsId,deleteApiV1OpenItemsId,postApiV1OpenItemsIdComplete,postApiV1OpenItemsIdConvert,postApiV1OpenItemsIdReopen,getApiV1OpenItemsIdMessages,postApiV1OpenItemsIdMessages,postApiV1OpenItemsIdMessagesSeen}};
export type GetApiV1OpenItemsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getOpenItems>['getApiV1OpenItems']>>>
export type PostApiV1OpenItemsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getOpenItems>['postApiV1OpenItems']>>>
export type PutApiV1OpenItemsIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getOpenItems>['putApiV1OpenItemsId']>>>
export type DeleteApiV1OpenItemsIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getOpenItems>['deleteApiV1OpenItemsId']>>>
export type PostApiV1OpenItemsIdCompleteResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getOpenItems>['postApiV1OpenItemsIdComplete']>>>
export type PostApiV1OpenItemsIdConvertResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getOpenItems>['postApiV1OpenItemsIdConvert']>>>
export type PostApiV1OpenItemsIdReopenResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getOpenItems>['postApiV1OpenItemsIdReopen']>>>
export type GetApiV1OpenItemsIdMessagesResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getOpenItems>['getApiV1OpenItemsIdMessages']>>>
export type PostApiV1OpenItemsIdMessagesResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getOpenItems>['postApiV1OpenItemsIdMessages']>>>
export type PostApiV1OpenItemsIdMessagesSeenResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getOpenItems>['postApiV1OpenItemsIdMessagesSeen']>>>
